<template>
  <a-select class="item-input card-shadow" placeholder="Industry filter" allowClear
    v-model="vmodel"
    @change="changeHandle">
    <a-select-option
      v-for="(item, ind) in data"
      :key="ind"
      :value="item.id"> {{item.industry_title_zh}} </a-select-option>
  </a-select>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      default: undefined
    }
  },
  computed: mapGetters([
    'selectIndustry'
  ]),
  data () {
    return {
      code: '',
      vmodel: '',
      data: [],
      cond: {
        page_num: '1',
        page_size: '99'
      }
    }
  },
  watch: {
    vmodel (val) {
      this.$emit('input', val)
    }
  },
  mounted () {
    this.vmodel = this.value
    this.initHandle()
  },
  methods: {
    changeHandle (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },
    initHandle () {
      if (this.selectIndustry.length) {
        this.data = this.selectIndustry
      } else {
        this.readList()
      }
    },
    readList () {
      this.get({
        url: 'industryRead',
        data: this.cond
      }, (res) => {
        this.loading = false
        if (res.code) {
          this.data = res.data.items
          this.$store.commit('cacheSelectData', {
            key: 'selectIndustry',
            value: res.data.items
          })
        } else {
          this.data = []
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Models/comps/selectedIndustry.vue